/* eslint-disable import/prefer-default-export */

export function stringIsFalsy(s: string | null): boolean {
  if (s === '' || s === 'false' || s === 'undefined' || s === 'null' || s === '0' || s === 'off') {
    return true
  }
  return false
}

export const makeID = (length: number = 7) => {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < length; i += 1) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}
